import styled from 'styled-components';
import { IonPage } from '@ionic/react';
import { Modal } from '$gcomponents/reusables';

export const IonPageWrapper = styled(IonPage)`
  .MuiTableHead-root {
    border-bottom: 1px solid #ccc;
  }
`;

export const ModalWrapper = styled(Modal)``;
